import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { LereToursPricingApplyRequest, ToursPricingApplyStatus } from '~/components/LERE/types';

import LereService from '~/services/LereService';

import { lereToursPricingSuggestionsQueryKeys } from './lereToursPricingSuggestionsQueryKeys';

export function useApplyToursPricingSuggestion() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (params: LereToursPricingApplyRequest) => {
      return await LereService.applyToursPricingSuggestion(params);
    },
    onSuccess: (_data, variables) => {
      const verb: Record<ToursPricingApplyStatus, string> = {
        accepted: 'applied',
        rejected: 'rejected',
      };
      queryClient.invalidateQueries({ queryKey: lereToursPricingSuggestionsQueryKeys.all });
      enqueueSnackbar(`Recommendation ${verb[variables.status]} successfully`, { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to apply recommendation: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
